export const THEMES = ["red", "green", "blue"];

export function getTheme() {
  return localStorage.getItem("mawilu_theme") || "green";
}

export function applyTheme(theme) {
  const t = THEMES.includes(theme) ? theme : "green";
  document.documentElement.setAttribute("data-theme", t);
  localStorage.setItem("mawilu_theme", t);
}
